import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ImageNext, UIContext } from '@carvana/purchase-helpers';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import * as sc from './vehicle-snapshot.styles';

const defaultProps = {
  isInPurchaseHeaderBucket: false
}

const VehicleSnapshot = ({ isInPurchaseHeaderBucket = false } = defaultProps) => {
  const uiState = useContext(UIContext);
  const isMobile = uiState.screenSize.isMobile;
  const vehicle = useSelector((state: any) => state?.vehicle);
  const yearMakeModelText = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;

  const isNativeWebview = /CarvanaNativeWebView/gi.test(navigator?.userAgent);

  const { trackEvent } = useContext(AnalyticsContext);

  const isContainerClickable =
    (!isMobile && !isInPurchaseHeaderBucket) ||
    (isInPurchaseHeaderBucket && !isNativeWebview);

  return (
    <sc.Container
      onClick={() => {
        if (isContainerClickable) {
          trackEvent('pp_clicked_vdp');
          if (isInPurchaseHeaderBucket)
            window.open(`/vehicle/${vehicle.vehicleId}`, '_self');
          else window.open(`/vehicle/${vehicle.vehicleId}`);
        }
      }}
    >
      <sc.ImageContainer>
        <ImageNext
          alt={`${yearMakeModelText}`}
          fallbackSrc={vehicle.evoxImageUrl}
          src={vehicle.srcImageUrl}
          styles={sc.imageStyles}
        />
      </sc.ImageContainer>
      <sc.TextContainer>
        <sc.YearMakeModelText>{yearMakeModelText}</sc.YearMakeModelText>
        <sc.TrimText>{vehicle.trim}</sc.TrimText>
        {isInPurchaseHeaderBucket && !isNativeWebview && (
          <sc.VdpLink>View vehicle details</sc.VdpLink>
        )}
      </sc.TextContainer>
      {!isInPurchaseHeaderBucket && <sc.NavTabArrow />}
    </sc.Container>
  );
};

export default VehicleSnapshot;
